import type { Calendar } from '../../../domain/meeting';
import type { EventDataChanged } from '../../../domain/message';
import { ENABLE_TOOLS_KEY, OPENED_CALENDAR_KEY } from '../../../domain/settings';
import type { Commands } from '../../../messageHandler';
import DataExtractionService from '../../dataExtraction/DataExtractionService';
import ScrappingMonitoringService from '../../scrapingMonitoring/scrappingMonitoringService';

const handleDataChange = (commands: Commands, event: EventDataChanged, calendar: Calendar, url?: URL) => {
  const meeting = DataExtractionService.meeting.extractMeeting(event.data, calendar);

  if (event.data?.length > 0 && commands.getState().isOpen) {
    ScrappingMonitoringService.dispatchScrappingEvent({ data: event.data, url });
  }

  if (meeting) {
    if (
      !meeting.isNew &&
      DataExtractionService.meeting.isTheSameMeetingWithLessEmails(meeting, commands.getCollectedMeeting())
    ) {
      window.parent.postMessage({ message: 'google meeting', meeting: commands.getCollectedMeeting() }, '*');
      return;
    }

    window.parent.postMessage({ message: 'google meeting', meeting }, '*');

    commands.setCollectedMeeting(meeting);
  } else {
    commands.resetCollectedMeeting();
  }
};

const handleIframeLoad = (commands: Commands) => {
  commands.setCalendarPage();

  const hasCalendarOpenedAutomatically = !!JSON.parse(window.localStorage.getItem(OPENED_CALENDAR_KEY) || 'false');
  const isCalendarEnabled = commands.getSettingsStorageValue(ENABLE_TOOLS_KEY);

  if (!isCalendarEnabled && !hasCalendarOpenedAutomatically) {
    window.parent.postMessage({ message: 'open' }, '*');
    window.localStorage.setItem(OPENED_CALENDAR_KEY, 'true');
  }
};

export const calendarMessageHandler = {
  handleDataChange,
  handleIframeLoad,
};
